// Converts the print-tag queue into a virtual Store Action displayed with backend action items.
import { StoreAction, StoreActionPage } from './storeActionDomain';

export const PRINT_EDIT_PRICETAG_ACTION_TYPE = 'PRINT_EDIT_PRICETAG';
export const PRINT_EDIT_PRICETAG_ACTION_ID = 'VIRTUAL-PRINT-EDIT-PRICETAG';
export const PRINT_EDIT_PRICETAG_DESTINATION = '/inventory/printeditpricetag';
export const PRINT_EDIT_PRICETAG_DESCRIPTION = 'Print Tag(s) in Print Queue';

const createVirtualPriceTagAction = (currentDate: string): StoreAction => ({
  storeActionItemId: PRINT_EDIT_PRICETAG_ACTION_ID,
  storeActionType: PRINT_EDIT_PRICETAG_ACTION_TYPE,
  storeActionCategory: 'INV',
  description: PRINT_EDIT_PRICETAG_DESCRIPTION,
  status: 'ACTIVE',
  active: true,
  createdAt: currentDate,
  redirectUrl: PRINT_EDIT_PRICETAG_DESTINATION,
  isVirtual: true,
});

export const composePriceTagQueueAction = (
  page: StoreActionPage,
  hasPriceTagQueue: boolean,
  currentDate: string = new Date().toISOString()
): StoreActionPage => {
  if (
    !hasPriceTagQueue ||
    page.items.some(
      (item) => item.storeActionItemId === PRINT_EDIT_PRICETAG_ACTION_ID
    )
  ) {
    return page;
  }

  const virtualAction = createVirtualPriceTagAction(currentDate);
  const items = [virtualAction, ...page.items];
  const countsByCategory = {
    ...page.countsByCategory,
    INV: (page.countsByCategory.INV || 0) + 1,
  };

  return {
    ...page,
    items,
    total: page.total + 1,
    countsByCategory,
  };
};
